var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0}),React.createElement("g",{"id":"icomoon-ignore","key":1}),React.createElement("path",{"d":"M75.244 178.171h981.209c34.736 0 60.778 26.045 60.778 60.778 0 17.367-8.681 26.045-17.367 43.409l-486.258 555.729c-26.045 26.045-60.778 26.045-86.838 0 0 0 0 0 0 0l-494.951-555.729c-26.045-26.045-17.367-60.778 8.681-86.838 0-8.681 17.367-17.367 34.736-17.367z","key":2})]);
}

ArrowDown.displayName = "ArrowDown";

ArrowDown.defaultProps = {"version":"1.1","width":"1123","height":"1024","viewBox":"0 0 1123 1024"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
